import { h } from "preact";
import { TransitionGroup } from "preact-transitioning";
import {useEffect, useState} from "preact/hooks";
import { SlideImage } from "./SlideImage";

export type ImageSlidesProps = {
  slides: any;
  activeSlideId: number;
  animationType?: "disintegration" | "fading"
} & any

const ImageSlides = ({ slides, activeSlideId }: ImageSlidesProps ) => {
        return (
          <div className="slider2">
            <TransitionGroup appear exit={true} duration={1500}>
              {slides.map((slide: any, i: number) => {
                const {
                  image_webp
                } = slide;
                return ( 
                  <SlideImage 
                    key={i} 
                    image={image_webp}
                    isActive={activeSlideId === i} 
                  /> 
                );
              })}
            </TransitionGroup>
          </div>
      );
}

export { ImageSlides };
